import Device from './../devices/device';
import settings from './../devices/all/settings';
import store from '../store';
import Utils from './Utils';
import ChannelSingleton from '../components/Epg/ChannelsSingleton';
import * as api from '../requests/loader';
import { MODAL_ADDON, MODAL_CALL_CENTER , showModal } from '../actions/modal';
import {Dates} from '../packages/dates';
import MultipleLangLive from '../AAF/LanguageLive/MultipleLangLive';
import AAF from 'src/AAF/AAF';
import { LINEAL_CHANNELS_TTL } from 'src/AAF/Resilence/TTLConstants';
import NewRelic from 'src/utils/trackers/NewRelic';

const TTLItem = LINEAL_CHANNELS_TTL;

class PlayerStreamingUtils {
  constructor() {
    this.getLangCombo = this.getLangCombo.bind(this);
    this.resolveStreamType = this.resolveStreamType.bind(this);
    this.ifMultipleAudio = this.ifMultipleAudio.bind(this);
    this.isMultipleStreamType = this.isMultipleStreamType.bind(this);
    this.getLangIDByOptionID = this.getLangIDByOptionID.bind(this);
    this.getEncodesByContentID = this.getEncodesByContentID.bind(this);
    this.getLangIDByContentID = this.getLangIDByContentID.bind(this);
    this.getLangOptionIDByContentID = this.getLangOptionIDByContentID.bind(this);
    this.getSubtitleForSelectedLang = this.getSubtitleForSelectedLang.bind(this);
    this.getAudioForSelectedLang = this.getAudioForSelectedLang.bind(this);
    this.replaceSourceMedia = this.replaceSourceMedia.bind(this);
    this.checkSusc = this.checkSusc.bind(this);
    this.getPBI = this.getPBI.bind(this);
    this.canGoToPastEPGCard = this.canGoToPastEPGCard.bind(this);
    this.pUtils = Device.getDevice().getPlayerUtil();
    this.setChangePath = this.setChangePath.bind(this);
    this.changePath = null;
    this.deviceId = Utils.getDeviceID();
  }

  setChangePath(func) {
    this.changePath = func;
  }

  /*
   get an object of lang options
   @param Object language attr from pgm common extendedcommon.....language.....options.option

   options: [
   {
   is_current: true,
   group_id: "733079",
   content_id: "702214",
   option_id: "O-ES",
   label_short: "Audio 1",
   label_large: "Audio 1",
   encodes: [
   "smooth_streaming",
   "dashwv",
   "widevine_classic"
   ]
   },
   {
   is_current: false,
   group_id: "733079",
   content_id: "702216",
   option_id: "S-ES",
   label_short: "Audio 2",
   label_large: "Audio 2",
   encodes: [
   "smooth_streaming",
   "dashwv",
   "widevine_classic"
   ]
   }
   ]
   */

  async getPBI(groupId) {
    return await api.purchaseButtonInfo(groupId, true);
  }

  showModalSusc(provider, groupId, offerButtons, pbi, cb=()=>{}, data = {}) {
    const modalProps = {
      groupId,
      provider,
      pbi,
      backCallback: cb,
      data
    };

    store.dispatch(
      showModal({
        //modalType: MODAL_CALL_CENTER,
        modalType: MODAL_ADDON,
        modalProps: modalProps
      })
    );
  }

  canPlayChannel(group_id, isFallback) {
    let channel = null;
    if(!isFallback) {
      AAF.TTLUtil.verifyTTLItem(TTLItem, () => { AAF.TTLUtil.setLinealChannels() }, 'PlayerStreamingUtils[canPlayChannel]');
    }
    const linealChannels = store.getState().linealChannels;
    if (Array.isArray(linealChannels)) {
      channel = linealChannels.find(tchannel => tchannel.id == group_id);
    }

    return channel && channel.play ? channel : false;
  }

  async checkSusc(pgm, group_id, cb = () =>{} , eventData={} ) {

    if (!this.canPlayChannel(group_id)) {
      NewRelic.actionText(`${'LogType: Newrelic File: PlayerStreamingUtils'} ${'Method: checkSusc'} ${'Message: No tiene permisos, va a checar por PBI'}`);

      const purchaseButtonInfo = await this.getPBI(group_id);
      let offerButtons =
        purchaseButtonInfo &&
        purchaseButtonInfo.listButtons &&
        purchaseButtonInfo.listButtons.button;
      if (!Array.isArray(offerButtons)) {
        offerButtons = [];
      }

      const prov = Utils.getChannelInfo(group_id);
      const code =
        prov && prov.proveedor && prov.proveedor.codigo ? prov.proveedor.codigo : null;

      //Cambiaron Apis y ahora getMedia no devuelve esta info
      const provider = code; // pgm.group ? pgm.group.common.extendedcommon.media.proveedor.nombre : (pgm.media.proveedor ? pgm.media.proveedor.nombre: '');
      this.showModalSusc(provider, group_id, offerButtons, purchaseButtonInfo, cb, eventData);

      return false;
    } else {
      NewRelic.actionText(`${'LogType: Newrelic File: PlayerStreamingUtils'} ${'Method: checkSusc'} ${'Message: Si tiene permisos'}`);
      return true;
    }
  }

  getLangCombo(contentLanguages) {
    const y = contentLanguages;
    const options = [];
    let i;
    for (i = 0; i < contentLanguages.length; i++) {
      options.push(contentLanguages[i]);
    }

    return options;
  }

  getLangComboLive(gid, streamType) {
    let result = null;
    if (MultipleLangLive.isEnabled() && MultipleLangLive.streamIsEnabled(streamType)) {
      // console.log('[MA-LIVE] Opciones de Modal gid', gid, ' streamType ', streamType);
      const options = Utils.getAudioLangByGroupId(gid);
      result = {
        audio: options && options.audio ? options.audio : null,
        subtitle: options && options.subtitle ? options.subtitle : null
      };
      // console.log('[MA-LIVE]-Opciones de Modal', options);
    } else {
      console.log('[MA-LIVE] Opciones de Modal false por default');
    }

    return result;
  }

  resolveStreamType(encodes, provider, isLive) {
    return this.pUtils.resolveStreamType(encodes, provider, isLive);
  }

  // @param streamType is in "single form", i.e. SS and here we compare with "_MA"
  ifMultipleAudio(streamType, isLive) {
    return this.pUtils.ifMultipleAudio(streamType, isLive);
  }

  isMultipleStreamType(streamType) {
    let ret = streamType.indexOf(settings.prepend_multiple) != -1;
    return ret;
  }

  /*
   optionId is a option_id from lang options, i.e. S-ES
   return language id, i.e. ES, PT
   */
  getLangIDByOptionID(optionId, langOptions) {
    let i;
    let lang_id;
    // TODO change to find/filter ES6 syntax
    for (i = 0; i < langOptions.length; i++) {
      if (langOptions[i].option_id === optionId) {
        lang_id = langOptions[i].id;
        break;
      }
    }

    return lang_id;
  }

  /*
   contentId is a content_id from lang options
   return encodes array
   */
  getEncodesByContentID(contentId, langOptions) {
    let i;
    let encodes = null;
    // TODO change to find/filter ES6 syntax
    for (i = 0; i < langOptions.length; i++) {
      if (langOptions[i].content_id === contentId) {
        encodes = langOptions[i].encodes;
        break;
      }
    }

    return encodes;
  }

  /*
   contentId is a content_id from lang options
   return language id, i.e. ES, PT
   */
  getLangIDByContentID(contentId, langOptions) {
    let i;
    let lang_id;
    // TODO change to find/filter ES6 syntax
    for (i = 0; i < langOptions.length; i++) {
      if (langOptions[i].content_id === contentId) {
        lang_id = langOptions[i].id;
        break;
      }
    }

    return lang_id;
  }

  /*
   contentId is a content_id from lang options
   return language option_id, i.e. D-ES, S-PT
   */
  getLangOptionIDByContentID(contentId, langOptions) {
    let i;
    let lang_id;
    // TODO change to find/filter ES6 syntax
    for (i = 0; i < langOptions.length; i++) {
      if (langOptions[i].content_id === contentId) {
        lang_id = langOptions[i].option_id;
        break;
      }
    }

    return lang_id;
  }

  /*
   @param lang_id = ORIGINAL, PT, ES, etc. from PGM response
   @param (from PGM) multiple = {
   options: {
   PT: {
   internal: "por",
   external: "http://tvuspss2qro.clarovideo.com/multimediav81/plataforma_vod/MP4/201706/MAH000034_full/MAH000034_full_T0000_SUBT_POR.VTT"
   },
   ES: {
   internal: "spa",
   external: "http://tvuspss2qro.clarovideo.com/multimediav81/plataforma_vod/MP4/201706/MAH000034_full/MAH000034_full_T0000_SUBT_SPA.VTT"
   }
   },
   selected: "ES"
   }

   getSubtitle from lang options
   return url for VTT
   */
  getSubtitleForSelectedLang(lang_id, multiple) {
    console.log('[RESOLVEEEEED subtitle]', lang_id, multiple);

    let vtt_url = null;
    if (!lang_id) return null;
    if (!multiple) return null;

    if (multiple.options[lang_id]) {
      if (multiple.options[lang_id].external) {
        vtt_url = multiple.options[lang_id].external;
      }
    }

    return vtt_url;
  }

  /*
   @param lang_id = ORIGINAL, PT, ES, etc. from PGM response
   @param (from PGM) multiple = {
   options: {
   PT: "por",
   ORIGINAL: "ori",
   ES: "spa"
   },
   selected: "ORIGINAL"
   }
   }

   getSubtitle from lang options
   return id of audioTrack: por, ori, spa
   */
  getAudioForSelectedLang(lang_id, multiple) {
    console.log('[RESOLVEEEEED] audio', lang_id, multiple);
    let id_audiotrack = null;
    if (!lang_id) return null;
    if (!multiple) return null;

    console.log('[RESOLVEEEEED] audio multiple.options', multiple.options);
    console.log('[RESOLVEEEEED] audio multiple.options.ES', multiple.options[lang_id]);
    if (multiple.options[lang_id]) {
      id_audiotrack = multiple.options[lang_id];
      console.log('[RESOLVEEEEED] found! ', id_audiotrack);
    }
    console.log('[RESOLVEEEEED] resolved: ', id_audiotrack);

    return id_audiotrack;
  }

  getAudioToPlay(option_id, options) {
    let audio_id = null;
    let y;
    for (y = 0; y < options.length; y++) {
      if (options[y].option_id === option_id) {
        if (options[y].audio) {
          audio_id = options[y].audio;
        }
      }
    }

    return audio_id;
  }

  getSubtitleToPlay(option_id, options) {
    let subtitle_id = null;
    let y;
    for (y = 0; y < options.length; y++) {
      if (options[y].option_id === option_id) {
        if (options[y].subtitle) {
          subtitle_id = options[y].subtitle;
        }
      }
    }

    return subtitle_id;
  }

  getSingleSubtitleToPlay(contentId, options) {
    let subtitle_id = null;
    let y;
    for (y = 0; y < options.length; y++) {
      if (options[y].content_id === contentId) {
        if (options[y].subtitle) {
          subtitle_id = options[y].subtitle;
        }
      }
    }

    return subtitle_id;
  }

  async replaceSourceMedia(
    pgm,
    streamType,
    provider = null,
    providerCode = null,
    isLive = false,
    streamContentType = null
  ) {
    return await this.pUtils.replaceSourceMedia(
      pgm,
      streamType,
      provider,
      providerCode,
      isLive,
      streamContentType
    );
  }

  /**
   * Casos particulares de no-playing aquí, por ejemplo crackle en samsung,
   * hisense, HBO en hisense, CRACKLE en samsung 2013, etc.
   *
   * @param {*} pgm
   * @param {*} streamType puede ser null
   */
  canPlayPGM(pgm, streamType) {
    if (Utils.isFunction(this.pUtils.canPlayPGM)) {
      return this.pUtils.canPlayPGM(pgm, streamType);
    }

    return true;
  }

  /**
   *
   */
  canGoToPastEPGCard() {
    const configuration = Utils.getApaMetadataKey('timeshift_npvr_configuration', null, 'vcard_past_epg_event');

    if (configuration){
      return configuration.enable;
    }

    return false;
  }

  getButtonRecord(key) {
    const configuration = Utils.getApaMetadataKey('timeshift_npvr_configuration', null, key);

    if (configuration){
      return configuration.enable;
    }

    return false;
  }

  // Return a moment object
  getStarttimeTimeshift(groupId) {
    /*
     A las 13:01pm de hoy 29 mayo:
     STARTIME TIMESHIFT]  now:  1527617022 PlayerStreamingUtils.js:431
     [STARTIME TIMESHIFT] ChannelSingleton.getTimeshift timeshift de linnealChannels  24 ChannelsSingleton.js:217
     [STARTIME TIMESHIFT] ChannelSingleton.getTimeshift timeshift de timeshiftContentList  6 ChannelsSingleton.js:228
     [STARTIME TIMESHIFT] ChannelSingleton.getTimeshift:  21600 PlayerStreamingUtils.js:434
     [STARTIME TIMESHIFT] nowDiff:  1527595422 PlayerStreamingUtils.js:439
     [STARTIME TIMESHIFT]  2018/05/29 07:04:00 PlayerStreamingUtils.js:454
     ########
     */
    // in seconds
    const now = Utils.now(true).unix();
    let channel_timeshift = ChannelSingleton.getTimeshift(groupId, true);
    channel_timeshift = channel_timeshift + this.getSafeTime();

    //const now = m().unix();
    let nowDiff = now - channel_timeshift;
    console.log('[STARTIME TIMESHIFT] nowDiff: ', nowDiff);

    let startTimeTimeshift = new Dates().unix(nowDiff);
    let seconds = startTimeTimeshift.seconds();
    let addSeconds = 0;
    if (seconds > 30) {
      addSeconds = 60 - seconds;
    }
    // Incluye segs en cero
    if (seconds < 30) {
      addSeconds = 30 - seconds;
    }
    if (addSeconds > 0) {
      startTimeTimeshift.add(addSeconds, 's');
    }
    console.log('[STARTIME TIMESHIFT] ', startTimeTimeshift.format('YYYY/MM/DD hh:mm:ss'));

    return startTimeTimeshift;
  }

  getSafeTime() {
    const timeshiftMetadata = Utils.getApaMetadataKey('epg_event_safe_time', '{}', 'timeshift');

    if (timeshiftMetadata) {
      return timeshiftMetadata.start;
    }else{
      return 0;
    }
  }

  getMaxTimeshiftAllowed(groupId) {
    return ChannelSingleton.getTimeshift(groupId, true);
  }

  getPaywayToken(groupId, isFallback) {
    if(!isFallback) {
      AAF.TTLUtil.verifyTTLItem(TTLItem, () => { AAF.TTLUtil.setLinealChannels() }, 'PlayerStreamingUtils[getPaywayToken]');
    }
    const linealChannels = store.getState().linealChannels;

    if (Array.isArray(linealChannels)) {
      const foundChannel = linealChannels.find(channel => channel.id == groupId);
      if (foundChannel) {
        return foundChannel.timeshift_token;
      }
    }

    return '';
  }
}

export default PlayerStreamingUtils;



// WEBPACK FOOTER //
// ./src/utils/PlayerStreamingUtils.js